module.exports = __webpack_public_path__ + "media/react/marketing/sections/value_props/assets/green/timely_guidance_icon-bd81f7d700acdb5264f66a2c1123d521.svg";